import { forwardRef } from 'react';
import Select from 'react-select';

const CustomReactSelect = forwardRef((props: any, ref) => {
  // if (props.allowSelectAll) {
  //   return (
  //     <div className="input-group">
  //       <Select {...props} ref={ref}/>
  //       <span className="input-group-append">
  //         <button
  //           type="button"
  //           onClick={() => props.onChange(props.options)}
  //           className="btn btn-primary"
  //         >
  //           Select All
  //         </button>
  //       </span>
  //     </div>
  //   );
  // }
  return <Select {...props} ref={ref} />;
});
export default CustomReactSelect;
